module.exports = __webpack_public_path__ + "static/media/sh.d264f184.svg";